import { RmsContractProductsResponse } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum ProductsActionTypes {
  LOAD = '[Rms Products] Load products',
  LOAD_COMPLETE = '[Rms Products] Load products complete',
  RESET = '[Rms Products] Reset',
}

/**
 * Starts a load of the product-list from the application's store.
 */
export class ProductsLoadAction implements Action {
  readonly type = ProductsActionTypes.LOAD;

  constructor() {}
}

/**
 * Signals the end of loading a product-list from the store.
 * The handler in the reducer uses filterUniqueProducts, so duplicates should be removed by that.
 */
export class ProductsLoadCompleteAction implements Action {
  readonly type = ProductsActionTypes.LOAD_COMPLETE;

  constructor(public payload: RmsContractProductsResponse) {}
}

/**
 * Wipes clean the product-list.
 */
export class ProductsResetAction implements Action {
  readonly type = ProductsActionTypes.RESET;

  constructor() {}
}

export type ProductsActions = ProductsLoadAction | ProductsLoadCompleteAction | ProductsResetAction;
